import React, { useEffect } from "react";

import {
  AppNotificationHost,
  appNotification,
  type AppNotificationKind,
} from "@/components/ui/AppNotification";

/**
 * Mounts AppNotificationHost and the optional embed `hub-toast` CustomEvent bridge.
 * Product code must call `appNotification.*` directly — do not reintroduce useToast / sonner facades.
 *
 * Embed contract (optional): `window.dispatchEvent(new CustomEvent("hub-toast", { detail: { kind, message } }))`.
 */
export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    const onHubToast = (event: Event) => {
      const detail = (event as CustomEvent<{ kind?: string; message?: unknown }>).detail;
      const message = typeof detail?.message === "string" ? detail.message : "Hub action completed.";
      const kind: AppNotificationKind =
        detail?.kind === "error" || detail?.kind === "warning" || detail?.kind === "info"
          ? detail.kind
          : "success";
      appNotification.show(kind, message);
    };
    window.addEventListener("hub-toast", onHubToast);
    return () => window.removeEventListener("hub-toast", onHubToast);
  }, []);

  return (
    <>
      {children}
      <AppNotificationHost />
    </>
  );
};
